
import CallToAction from "components/Cursos/CallToAction";
import Card from "components/Cursos/Card";
import CardAnim from "components/Cursos/CardAnim";
import NivelesCard from "components/Cursos/NivelesCard";
import HeaderA from "components/Headers/HeaderA";
import React, { useState } from "react";
import { useRouteColor } from "../hooks/useRouteColors";
import WhyCard from "components/Index/WhyCard";

const fakeData = [
  {
    curso: "Titulo del curso",
    fichaTecnica: [
      {
        icon: "fa-solid fa-person-chalkboard",
        titulo: "Modalidad",
        descripcion: "Presencial y virtual, según disponibilidad.",
      },
      {
        icon: "fa-solid fa-calendar-days",
        titulo: "Duración ",
        descripcion: "24 horas por nivel.",
      },
      {
        icon: "fa-solid fa-ranking-star",
        titulo: "Niveles",
        descripcion: "Intermedio, intermedio alto y avanzado.",
      },
      {
        icon: "fa-solid fa-users",
        titulo: "Dirigido a",
        descripcion:
          "Profesionales, técnicos, emprendedores y líderes que buscan fortalecer su comunicación en inglés.",
      },
      {
        icon: "fa-solid fa-bullhorn",
        titulo: "Requisitos",
        descripcion:
          "Nivel mínimo B1 (intermedio) comprobado mediante prueba de clasificación.",
      },
      {
        icon: "fa-solid fa-clock",
        titulo: "Horario",
        descripcion: "Flexible, según disponibilidad del estudiante.",
      },
    ],
    descripcionUno: "Primera descripcion del curso",
    descripcionDos: "Mas informacion relevante",
    imgUno: "https://brightonenglishcenter.edu.co/img/WEB14.jpeg",
    imgDos: "https://brightonenglishcenter.edu.co/img/WEB15.jpeg",
    imgTres: "https://brightonenglishcenter.edu.co/img/web5.jpg",
    estructura: [
      {
        color: "#ff7202",
        nivel: "Algunos niveles",
        info: "Alguna informacion sobre el nivel",
      },
      {
        color: "#ffe500",
        nivel: "Algunos niveles",
        info: "Alguna informacion sobre el nivel",
      },
      {
        color: "#71dd06",
        nivel: "Algunos niveles",
        info: "Alguna informacion sobre el nivel",
      },
      {
        color: "#00b1c9",
        nivel: "Algunos niveles",
        info: "Alguna informacion sobre el nivel",
      },
      {
        color: "#0049ff",
        nivel: "Algunos niveles",
        info: "Alguna informacion sobre el nivel",
      },
      {
        color: "#b100e1",
        nivel: "Algunos niveles",
        info: "Alguna informacion sobre el nivel",
      },
    ],
    descripcionEstructura: "Descripcion de la estructura",
    objetivos: [
      {
        num: 1,
        des: "Objetivos",
      },
      {
        num: 2,
        des: "Objetivos",
      },
      {
        num: 3,
        des: "Objetivos",
      },
      {
        num: 4,
        des: "Objetivos",
      },
    ],
    competencias: [
      {
        des: "Comunicación oral y escrita.",
        img: "https://brightonenglishcenter.edu.co/img/Escritura.webp",
      },
      {
        des: "Comprensión auditiva y lectora en contextos académicos y laborales.",
        img: "https://brightonenglishcenter.edu.co/img/Habla.webp",
      },
      {
        des: "Interacción efectiva en ambientes multiculturales.",
        img: "https://brightonenglishcenter.edu.co/img/Comunicacion.jpeg",
      },
      {
        des: "Desarrollo del pensamiento crítico, el análisis y la interpretación de manera efectiva.",
        img: "https://brightonenglishcenter.edu.co/img/entrevistas.webp",
      },
    ],
    metodologia: [
      {
        met: "Clases interactivas con enfoque 100% práctico.",
        img: "https://brightonenglishcenter.edu.co/img/Habla.webp",
      },
      {
        met: "Material didactico adaptado al nivel de trabajo.",
        img: "https://brightonenglishcenter.edu.co/img/Comunicacion.jpeg",
      },
      {
        met: "Trabajo colaborativo con retroalimentación personalizada del docente.",
        img: "https://brightonenglishcenter.edu.co/img/habilidad_listening.jpg",
      },
      {
        met: "Recursos digitales (plataforma virtual, audios, videos y lecturas acordes a cada nivel).",
        img: "https://brightonenglishcenter.edu.co/img/recursos.webp",
      },
    ],
    evaluacion: [
      "Evaluaciones durante el proceso",
      "Autoevaluación y retroalimentación docente.",
      "Proyecto final basado en un caso real de su campo profesional.",
      "Informe de progreso individual al cierre de cada nivel.",
    ],
  },
];

const CursosLayout = ({ data }) => {
  const datos = data ? data[0] : fakeData[0];
  const [activeIndex, setActiveIndex] = useState(null);
  const { bg } = useRouteColor();
  const sections = document.querySelectorAll("section");
  return (
    <>
      <div className="text-primario" style={{ backgroundColor: bg }}>
        <HeaderA
          titulo={datos.curso}
          info={datos.fichaTecnica}
          img={datos.imgUno}
        />
        <section className="">
          <div className="m-20 xl:m-40 flex flex-row items-center gap-10">
            <div className="w-1/2 hyphens-none text-xl xl:text-2xl space-y-5">
              {datos.descripcionUno ? (
                <p className="font-bold text-2xl xl:text-3xl">
                  {datos.descripcionUno}
                </p>
              ) : null}
              {datos.descripcionDos ? <p>{datos.descripcionDos}</p> : null}
            </div>
            <div className="w-1/2 h-[70vh] overflow-hidden rounded-lg rounded-tl-none group shadow-[-10px_10px_0px_0px_#0d2334]">
              <img
                width={1080}
                className="w-full h-full object-cover group-hover:scale-110 transition-all duration-300 ease-in-out"
                src={
                  datos.imgUno
                    ? datos.imgUno
                    : "https://brightonenglishcenter.edu.co/img/brighton-2.webp"
                }
                alt={datos.curso}
                loading="lazy"
              />
            </div>
          </div>
        </section>
        <section className="">
          {typeof datos.estructura === "string" ? (
            <div className="w-1/2 hyphens-none ">
              <h2 className="text-6xl font-Bebas text-primario">Estructura</h2>
              <p className="text-2xl">{datos.estructura}</p>
            </div>
          ) : typeof datos.estructura === "object" ? (
            <div className="">
              <div className="m-20 xl:m-40 grid grid-cols-2 2xl:grid-cols-3 gap-5 ">
                <div className="space-y-5 p-5">
                  <h2 className="text-7xl font-bold tracking-wider font-Bebas text-primario">
                    Estructura del Programa
                  </h2>
                  <p className="text-xl xl:text-2xl hyphens-none">
                    {datos.descripcionEstructura}
                  </p>
                </div>
                {datos.estructura.map((value, index) => (
                    <NivelesCard
                      key={index}
                      nivel={value.nivel}
                      info={value.info}
                      color={value.color}
                    />
                  
                ))}
              </div>
            </div>
          ) : null}
        </section>
        {datos.imgDos ? (
          <section className="w-full h-[120vh]">
            <img
              loading="lazy"
              width={1080}
              src={datos.imgDos}
              alt="Brighton Centro de Inglés"
              className="w-full h-full object-cover "
            />
          </section>
        ) : null}
        <section className="">
          <div className="m-20 xl:m-40 flex flex-row justify-evenly items-start">
            <div className="w-1/2 2xl:w-fit space-y-4 relative mb-28">
              {datos.objetivos.map((o, i) => (
                <div
                  key={i}
                  className={`sticky w-max top-1/4 `}
                  style={{
                    // left: `${i * 30}px`,
                    transform: `translateY(${i * 20}px) translateX(${
                      i * 20
                    }px)`,
                    zIndex: i + 1,
                  }}
                >
                  <Card num={o.num} des={o.des} />
                </div>
              ))}
            </div>
            <div className="w-1/2 2xl:w-fit sticky top-1/3 h-full">
              <h2 className="mb-28 text-6xl xl:text-7xl font-bold tracking-wider font-Bebas text-primario">
                Objetivos del curso
              </h2>
            </div>
          </div>
        </section>
        <section className="">
          <div className="m-20 xl:m-40 space-y-10">
            <div className="">
              <h2 className="text-6xl xl:text-7xl font-bold tracking-wider font-Bebas text-primario text-center">
                Competencias que desarrollarás
              </h2>
            </div>
            <div className="2xl:w-3/4 grid grid-cols-3 gap-5 mx-auto">
              {datos.competencias.map((value, index) => (
                 <div key={index} className="2xl:h-[200px]">
                   <WhyCard descripcion={value.des}  icono={value.icon}/>
                 </div> 
              ))}
            </div>
          </div>
        </section>
        <section className="">
          <div className="m-20 xl:m-40 space-y-20 xl:mx-auto xl:w-2/3">
            <div className="">
              <h2 className=" text-6xl xl:text-7xl font-Bebas font-bold tracking-wider text-primario left-0 static">
                Metodología
              </h2>
              <p className="text-2xl hyphens-none">
                Nuestro enfoque se basa en el aprendizaje comunicativo por
                competencias, donde el estudiante aprende inglés haciendo,
                participando y aplicando.
              </p>
            </div>
            <div className=" grid grid-cols-2 gap-5"> 
              {datos.metodologia.map((m, i) => (
                  <div
                    key={i}
                    className="relative h-[350px] bg-yellow-1 hyphens-none  overflow-hidden rounded-lg rounded-tl-none group border-solid border-4 border-primario "
                  >
                    <img
                      width={520}
                      className="w-full h-full object-cover transition-all duration-300 ease-in-out group-hover:scale-110"
                      src={m.img}
                      alt={m.met}
                    />
                    <div className="absolute z-10 top-0 left-0 w-full h-full text-transparent group-hover:bg-primario/50 group-hover:backdrop-blur-sm group-hover:text-white transition-all duration-300 ease-in-out flex flex-col justify-center p-10">
                      <p className=" text-center text-xl xl:text-2xl">
                        {m.met}
                      </p>

                    </div>
                  </div>
                ))}
            </div>
          </div>
          {/* <div className="w-full ">
            <CarruselHorizontal outputA="40%" outputB="-80%">
              {datos.metodologia.map((m, i) => (
                <div
                  key={i}
                  className="relative w-[350px] h-[450px] bg-primario hyphens-none  overflow-hidden rounded-[14px] group border-solid border-4 border-primario "
                >
                  <div className="absolute z-10 top-5 left-5 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out ">
                    <img
                      width={520}
                      className="w-16 object-cover"
                      src="https://brightonenglishcenter.edu.co/img/Logo-2024.png"
                      alt="Brighton Centro de Ingles"
                    />
                  </div>
                  <img
                    width={520}
                    className="w-full h-full object-cover brightness-75 group-hover:brightness-100 transition-all duration-300 ease-in-out group-hover:scale-110"
                    src={m.img}
                    alt={m.met}
                  />
                  <p className="absolute w-full text-center -bottom-full p-5 h-auto rounded-t-[14px] bg-terciario text-primario  group-hover:bottom-0 transition-all duration-300 ease-in-out font-bold">
                    {m.met}
                  </p>
                </div>
              ))}
            </CarruselHorizontal>
          </div> */}
        </section>
        {datos.imgTres ? (
          <section className="bg-primario h-[100vh]">
            <img
              loading="lazy"
              width={1080}
              className="w-full h-full object-cover"
              src={datos.imgTres}
              alt="Aprende inglés en Brighton"
            />
          </section>
        ) : null}
        <section className="my-16 mx-44">
          <div className="flex flex-row justify-center gap-10 w-full">
            <div className="w-1/3 self-center">
              <h2 className="text-5xl font-Bebas text-primario text-right">
                Evaluación
              </h2>
            </div>
            <div className="w-2/3 hyphens-none space-y-6 ">
              <p className="text-2xl">
                El proceso de evaluación combina la medición continua del
                progreso con actividades aplicadas:
              </p>
              <div className=" w-full h-[450px]  grid grid-cols-2 text-lg  gap-6">
                {datos.evaluacion.map((e, i) => {
                  const baseZ = 1;
                  const z = activeIndex === i ? 100 : baseZ;
                  return (
                    <div
                      key={i}
                      style={{
                        position: "relative",
                        zIndex: z,
                      }}
                      onMouseEnter={() => setActiveIndex(i)}
                      onMouseLeave={() => setActiveIndex(null)}
                      className="relative"
                    >
                      <CardAnim des={e} />
                    </div>
                  );
                })}
              </div>
              <p className="p-5 text-2xl border-solid border-4 bg-white border-primario rounded-lg shadow-[-10px_10px_0px_0px_#0D2334]">
                El estudiante recibe una certificación con Brighton que acredita
                su nivel alcanzado y las competencias desarrolladas, avalada por
                estándares internacionales.
              </p>
            </div>
          </div>
        </section>
        <section className="py-16 ">
          <CallToAction />
        </section>
      </div>
    </>
  );
};

export default CursosLayout;
